import { Box, SxProps, Theme, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';
import { CustomDivider } from '../custom-divider/CustomDivider';

export interface CustomSectionProps {
  title: string;
  leftSideCta?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const CustomSection: React.FC<PropsWithChildren<CustomSectionProps>> = ({
  title,
  children,
  leftSideCta,
  sx,
}) => (
  <Box sx={sx} component="section">
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Typography flex={1} variant="h6" fontWeight={'700'}>
        {title}
      </Typography>
      {leftSideCta}
    </Box>
    <CustomDivider sx={{ mb: 2 }} />
    <Box>{children}</Box>
  </Box>
);

export default CustomSection;
